import pickBy from 'lodash/pickBy';
import { StateFilters, ParsedFiltersForApi } from '../types/news_search.types';
import { POSTED_DATE_OPTIONS } from '../constants/news_search.constants';
const DEFAULT_PAGE_SIZE = 20;

const parseFiltersForApi = (incomingFilters: StateFilters): ParsedFiltersForApi => {
  const {
    query,
    postedDate: published_since,
    authors,
    topics: news_topics,
    sponsored,
    sortingField,
    pageNumber: number,
  } = incomingFilters;

  const rootParams = pickBy({
    query: query || null,
  });

  const nonRootParams = pickBy({
    authors: authors?.length ? authors : null,
    news_topics: news_topics?.length ? news_topics : null,
    sponsored: sponsored || null,
  });

  if (published_since) {
    const date = new Date();
    if (published_since === POSTED_DATE_OPTIONS[0]) {
      date.setFullYear(date.getFullYear(), date.getMonth() - 1);
      nonRootParams.published_since = date.toISOString().slice(0, 10);
    } else if (published_since === POSTED_DATE_OPTIONS[1]) {
      date.setFullYear(date.getFullYear() - 1);
      nonRootParams.published_since = date.toISOString().slice(0, 10);
    }
  }

  const sortingParam = pickBy({
    field: sortingField || null,
  });

  const paramsForApi = {
    ...rootParams,
    page: {
      size: DEFAULT_PAGE_SIZE,
      number,
    },
  };

  if (Object.keys(nonRootParams).length) {
    paramsForApi.filter = nonRootParams;
  }

  if (Object.keys(sortingParam).length) {
    paramsForApi.sorting = sortingParam;
  }

  return paramsForApi;
};

export { parseFiltersForApi };
